<vdr-chip *ngIf="entity.shippingAddress?.customFields?.allowSubstitutes">
    <clr-icon shape="check-circle" class="substitutes-allowed-icon"></clr-icon>
    Substitutes Allowed
</vdr-chip>
<vdr-chip *ngIf="!entity.shippingAddress?.customFields?.allowSubstitutes">
    <clr-icon shape="times-circle" class="substitutes-denied-icon"></clr-icon>
    Substitutes Denied
</vdr-chip>
